import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBilibiliComponent } from './simple-icons-bilibili.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBilibiliComponent ],
    exports:      [ SimpleIconsBilibiliComponent ],
    bootstrap:    []
})
export class SimpleIconsBilibiliModule {}
